import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react'

// import { YhOfferPrint } from "@/erp_subpackage/components/YhOfferPrint/offerPrint"
import { numberParseChina, repairFormatNum, fmoney } from '@/erp_subpackage/utils/util';
import { useDictModel } from '@/erp_subpackage/pages/base/dict/dictModel';
import { SettlePrint } from "@/erp_subpackage/components/settlePrint"
import { returnOrderPrintOne, returnOrderPrintNum } from "@/service/ordersService"
import moment from 'moment';
export function ReturnOrderPrint(props) {
    const { t } = useTranslation();
    const { loadData, visible, setPrint, selectedRowKeys } = props
    const [formVal, setFormVal] = useState({});
    const [maintenanceList, setMaintenanceList] = useState([]);
    const [itemList, setItemList] = useState([]);
    const { getTreeNodeName } = useDictModel();

    useEffect(() => {
        console.log(props)
         getDetailOne()
    }, [visible])
    const getDetailOne = async () => {
        console.log(selectedRowKeys[0])
        let { retData } = await returnOrderPrintOne(selectedRowKeys[0]);
        let { returnItemList, returnMaintainMaterialList, orderInfo, enterTime,returnOrderInfo, ...from } = retData
        // receivableTotalAmount = repairFormatNum(receivableTotalAmount)
        const newItemDetails = returnItemList?.map((item, index) => {
            return {
                ...item,
                No: index + 1
            }
        })
        const newMaterialDetails = returnMaintainMaterialList?.map((item, index) => {
            return {
                ...item,
                No: index + 1
            }
        })
        if (retData) {
            setMaintenanceList(newMaterialDetails ?? []);
            setItemList(newItemDetails?? []);
            // setFormVal({ ...from, receivableTotalAmount, receivableTotalAmountCN: numberParseChina(receivableTotalAmount), enterTime: enterTime })
            setFormVal({ ...from,...orderInfo, enterTime,...returnOrderInfo, })
        }
    }
    const printNum = async () => {
        await returnOrderPrintNum(selectedRowKeys[0]);
        await loadData();
    }
    const onClose = () => {
        setPrint(false)
    }
    const itemClumns = [
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.序号`),
            dataIndex: 'No',
        },
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.项目编号`),
            dataIndex: 'itemCode',
        },
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.项目名称`),
            dataIndex: 'itemName',
        },
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.工时数`),
            dataIndex: 'itemWorkHours',
        },
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.工时单价`),
            dataIndex: 'workHoursPrice',
            render: (text) => fmoney(text, 2)
        },
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.折扣`),
            dataIndex: 'itemDiscount',
            render: (text) => text? text+ "%":"100%"
        },
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.优惠`),
            dataIndex: 'preferentialAmount',
            render: (text) => fmoney(text, 2)
        },
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.工时费`),
            dataIndex: 'actualAmount',
            render: (text) => fmoney(text, 2)
        },
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.备注`),
            dataIndex: 'remark',
            render: (text) => <span style={{width:'150px'}}>{text}</span>
        },
    ]
    const columns = [
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.序号`),
            dataIndex: 'No',
        },
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.商品编号`),
            dataIndex: 'materialCode',
        },
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.商品名称`),
            dataIndex: 'materialName',
        },
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.单位`),
            dataIndex: 'unitName',
        },
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.数量`),
            dataIndex: 'materialNumber',
        },
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.单价`),
            dataIndex: 'unitPrice',
            render: (text) => fmoney(text, 2)
        },
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.折扣`),
            dataIndex: 'materialDiscount',
            render: (text) => text? text+ "%":"100%"
        },
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.金额`),
            dataIndex: 'actualAmount',
            render: (text) => fmoney(text, 2)
        },
        {
            title: t(`ordersManage.returnOrder.returnOrderPrint.备注`),
            dataIndex: 'remark',
            render: (text) => <span style={{width:'150px'}}>{text}</span>
        },
    ]
    let IHeader = [
        {
            fieldLabel: `${t(`ordersManage.returnOrder.returnOrderPrint.退单编号`)}:`,
            fieldValue: formVal.returnCode,
            className: "w35"
            // fieldValue: `${formVal.returnCode}(${getTreeNodeName(formVal?.status)})`
        },
        {
            fieldLabel: `${t(`ordersManage.returnOrder.returnOrderPrint.单据编号`)}:`,
            fieldValue: formVal.orderCode,
            className: "w40"
        },
         {
            fieldLabel: `${t(`ordersManage.returnOrder.returnOrderPrint.结算类型`)}:`,
            fieldValue: getTreeNodeName(formVal.settlementType),
            className: "w25"
        },
        {
            fieldLabel: `${t(`ordersManage.returnOrder.returnOrderPrint.结算方`)}:`,
            fieldValue: formVal.settlementParty, //getTreeNodeName(formVal.payType as string)
            className: "w75"
        }, {
            fieldLabel: `${t(`ordersManage.returnOrder.returnOrderPrint.打印日期`)}:`,
            fieldValue: moment(new Date()).format("YYYY-MM-DD HH:mm"),
            className: "w25"
        },
    ]
    return (
        <SettlePrint
            title={`${t(`ordersManage.returnOrder.returnOrderPrint.云豪车服`)} ${t(`ordersManage.returnOrder.returnOrderPrint.科技`)} ${t(`ordersManage.returnOrder.returnOrderPrint.服务有限公司修理结算单`)}`}
            visible={visible}
            onClose={onClose}
            printNum={printNum}
            columns={columns}
            itemClumns={itemClumns}
            itemDataSource={itemList}
            dataSource={maintenanceList.filter(item => item.num !== 0)}
            printHeader={formVal}
            printFooter={formVal}
            IHeader={IHeader}
        />

    )
}